module.exports = [
    {
        "label": "NZD",
        "value": "NZD"
    },
    {
        "label": "IDR",
        "value": "IDR"
    },
    {
        "label": "INR",
        "value": "INR"
    },
    {
        "label": "AUD",
        "value": "AUD"
    },
    {
        "label": "USD",
        "value": "USD"
    },
    {
        "label": "EUR",
        "value": "EUR"
    },
    {
        "label": "PHP",
        "value": "PHP"
    },
    {
        "label": "HKD",
        "value": "HKD"
    },
    {
        "label": "SGD",
        "value": "SGD"
    }

]